// extracted by mini-css-extract-plugin
module.exports = {"group_separator":"group_separator--T9WA4","line_separator":"line_separator--1o0pf","btn_add_new_group":"btn_add_new_group--2nCbA"};